"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToVector = void 0;
const core_1 = require("flow-connect/core");
const utils_1 = require("flow-connect/utils");
class ToVector extends core_1.Node {
    constructor() {
        super();
    }
    setupIO() {
        this.addTerminals([
            { type: core_1.TerminalType.IN, name: "x", dataType: "any" },
            { type: core_1.TerminalType.IN, name: "y", dataType: "any" },
            { type: core_1.TerminalType.OUT, name: "vector", dataType: "any" },
        ]);
    }
    created(options) {
        const { width = 100, name = "To Vector", style = {} } = options;
        this.width = width;
        this.name = name;
        this.style = Object.assign({ rowHeight: 10 }, style);
    }
    process(inputs) {
        if (typeof inputs[0] === "number" && typeof inputs[1] === "number") {
            this.setOutputs(0, { x: inputs[0], y: inputs[1] });
        }
        else if (Array.isArray(inputs[0]) && Array.isArray(inputs[1])) {
            let result = [];
            for (let i = 0; i < inputs[0].length; i++) {
                result.push({ x: inputs[0][i], y: inputs[1][i] });
            }
            this.setOutputs(0, result);
        }
        else {
            utils_1.Log.error("Type mismatch: Inputs to standard node 'ToVector' should be of same type");
        }
    }
}
exports.ToVector = ToVector;
